import { Box, Grid } from '@mui/material'
import { Card, ListItem } from 'components'
import { get } from 'lodash'
import { useLoadCustomer } from 'modules/customers/hooks'
import { useParams } from 'react-router-dom'
import { zipCodeMask } from 'utils'
import { ModalAddressProvider } from './context/modalAddress.context'

const columnLeft: any = [
  {
    label: 'Logradouro',
    key: 'address.name'
  },
  {
    label: 'Cidade',
    key: 'address.city'
  },
  {
    label: 'Estado',
    key: 'address.uf'
  }
]

const columnRight = [
  {
    label: 'CEP',
    key: 'address.cep',
    transform: (value: string) => zipCodeMask(String(value))
  },
  {
    label: 'Complemento',
    key: 'address.complement'
  },
  {
    label: 'Bairro',
    key: 'address.district'
  }
]

const AddressContexted = () => {
  const { id } = useParams()

  const { data: customer } = useLoadCustomer(id)

  return (
    <>
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <Card
              sx={{
                visibility: { xs: 'hidden', sm: 'visible', md: 'visible' },
                padding: { xs: 0, sm: '24px', md: '24px' },
                maxWidth: 600
              }}
            >
              <Box
                sx={{
                  visibility: { xs: 'visible', sm: 'visible', md: 'visible' }
                }}
              >
                <Grid container spacing={{ xs: 0, md: 3 }}>
                  <Grid item xs={12} md={6}>
                    {columnLeft?.map((item: any) => (
                      <ListItem
                        key={item.key}
                        label={item.label}
                        value={get(customer, item.key)}
                        transform={item?.transform}
                      />
                    ))}
                  </Grid>

                  <Grid item xs={12} md={6}>
                    {columnRight?.map((item: any) => (
                      <ListItem
                        key={item.key}
                        label={item.label}
                        value={get(customer, item.key)}
                        transform={item.transform}
                      />
                    ))}
                  </Grid>
                </Grid>
              </Box>
            </Card>
            {/* <Divider sx={{ display: { xs: 'flex', sm: 'none', md: 'none' } }} /> */}
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

export const Address = () => (
  <ModalAddressProvider>
    <AddressContexted />
  </ModalAddressProvider>
)
